// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioPlayerControls__container-b96f38 {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.AudioPlayerControls__actions-e8766d {
  display: flex;
  gap: 8px;
}

.AudioPlayerControls__button-d33916 {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/AudioPlayer/AudioPlayerUI/AudioPlayerControls/AudioPlayerControls.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n}\n\n.button {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioPlayerControls__container-b96f38`,
	"actions": `AudioPlayerControls__actions-e8766d`,
	"button": `AudioPlayerControls__button-d33916`
};
module.exports = ___CSS_LOADER_EXPORT___;
